import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireDatabase} from '@angular/fire/database';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MySchoolAddInstructorComponent } from 'src/app/my-school/my-school-add-instructor/my-school-add-instructor.component';
import _ from 'lodash';
import { AngularFirestore } from '@angular/fire/firestore';
import { PROFILES } from 'src/Constants';
import { typeWithParameters } from '@angular/compiler/src/render3/util';
import { Profile } from 'src/app/Models/profile.interface';
@Component({
  selector: 'app-my-school-instructor',
  templateUrl: './my-school-instructor.component.html',
  styleUrls: ['./my-school-instructor.component.css']
})
export class MySchoolInstructorComponent implements OnInit, OnDestroy, OnChanges {
  @Input() orgId: string;
  @Input() name: string;
  @Input() orgName: string;
  @Input() entityId: string;
  @Input() showAddButton: boolean;
  @Input() superAdmin: boolean;
  instructors:MatTableDataSource<Profile> = new MatTableDataSource<Profile>([])
  leaving =  new Subject()
  displayedColumns: string[] = ['name', 'email', 'city', 'country'];
  invitations = [];
  change = new Subject()

  // insturctor permissions
  iperm = {}

  //admin permissions
  aperm = {}
  constructor(
    public dialog: MatDialog,
    private afs: AngularFirestore,
    private db: AngularFireDatabase 
    ) { }

  ngOnInit(): void {
    this.setup()
  }

  setup = () => {
    if (!this.orgId) { return }

    if(this.superAdmin){
      this.displayedColumns =  ['name', 'email','entityId', 'uid', 'organization', 'preferences', 'permissions'];
    }

    this.afs.collection<Profile>(PROFILES, ref => ref.where('organization', '==', this.orgId))
    .valueChanges()
    .takeUntil(this.leaving)
    .takeUntil(this.change)
    .subscribe(instructors => {
      this.instructors = new MatTableDataSource(instructors);
    });

    this.afs.collection("Permissions")
      .doc(`${this.orgId}`)
      .collection("Admins")
      .snapshotChanges()
      .takeUntil(this.leaving)
      .takeUntil(this.change)
      .subscribe(entries => {
        entries.forEach(entry => {
          this.aperm[entry.payload.doc.id] = true
        })

      })

      this.afs.collection("Permissions")
      .doc(`${this.orgId}`)
      .collection("Instructors")
      .snapshotChanges()
      .takeUntil(this.leaving)
      .takeUntil(this.change)
      .subscribe(entries => {
        entries.forEach(entry => {
          this.iperm[entry.payload.doc.id] = true
        })


      })
  }
  
  ngOnChanges(){
    this.change.next()
      this.iperm = {}
      this.aperm = {}
    this.setup()
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(MySchoolAddInstructorComponent, {
      width: '250px',
      data: {email: '', emails: []}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (_.isArray(result)) {
        this.invitations = result;
      } else if (_.isString(result)) {
        this.invitations = [result];
      } else {
        // present the error
      }
        this.invitations && this.sendInvitations();
    });
  }

  fixEntityId = (instructor) =>  {
    this.afs.collection(PROFILES).doc(instructor.uid).update({entityId: this.entityId})
  }

  setAdmin = (instructor) => {
    if(!instructor?.uid){ return }
    this.afs.collection("Permissions").doc(`${this.orgId}`).collection("Admins").doc(instructor?.uid).set({approved: true})
  }


  setInstructor = (instructor) => {
    if(!instructor?.uid){ return }
    this.afs.collection("Permissions").doc(`${this.orgId}`).collection("Instructors").doc(instructor?.uid).set({approved: true})
  }


  sendInvitations = () => {
    //exclude instructors that are already invited
    const instructors: Profile[] = this.instructors as unknown as Profile[]
    let exclusions: string[] = _.map(instructors, profile => profile?.email)

    //exclude already invited individuals
    this.db.list(`Invitations/${this.orgId}`)
      .valueChanges()
      .take(1)
      .subscribe(xs => {
        exclusions = _.concat(exclusions, xs) as string[]
        const invites = _.difference(this.invitations, exclusions)
        _.forEach(invites, email => { 
            this.db.list(`Invitations/${this.orgId}`).push({
              sender: this.name,
              org: this.orgName, 
              entityId: this.entityId,
              email,
            } )
        })
      }) 
  }

  ngOnDestroy(): void {
    this.leaving.next(null)
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.instructors.filter = filterValue.trim().toLowerCase();
  }

  addInstructor = () => {
    this.openDialog()
  } 
}


